import AddRestaurantModal from "../../components/AddRestaurantModal/AddRestaurantModal";
import LoginLogo from "../../assets/LoginLogo.png";

const Register = () => {
  return (
    <div className="bg-bg-login/register min-h-screen flex flex-col items-center justify-start pt-20">
        <img src={LoginLogo} alt="Logo" className="w-auto h-auto mb-8" />

      <AddRestaurantModal />
    </div>
  );
};

export default Register;
